/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiOperationBindings } from '../../models/AaiOperationBindings';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends AaiOperationBindings
 * @author eric.wittmann@gmail.com
 */
export class Aai20OperationBindings extends AaiOperationBindings {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super(parent);
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }
}
Aai20OperationBindings["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20OperationBindings";
Aai20OperationBindings["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




